import Phaser  from "phaser";
import StartGame from "./StartGame";
import Kunai from "../ui/Kunai";

export default class Scene3 extends Phaser.Scene
{
    constructor()
{
    super("scene-3")
}
init(data)
{
 this.Platforms = undefined 
 this.player =undefined
 this.cursors = undefined
 this.kunais = undefined
 this.ButtonsSilver = undefined
 this.ButtonGold =undefined
 this.doors = undefined
 this.score = 0 
 this.scoreText = undefined
 this.timerLabel = undefined
 this.countdownTimer = 20 // berapa detik total 
 this.timedEvent = undefined
 this.checkPosition = false 
 this.Barrels = undefined
 //this.GreenBarrels = undefined
//this.score = data.score
 


}

preload()
{
    this.load.spritesheet('NinjaRun','images/SpriteSheet/NinjaRun.png',{frameWidth:363, frameHeight:458})
    this.load.spritesheet('NinjaDead','images/SpriteSheet/NinjaDead.png',{frameWidth:482,frameHeight:498})
    this.load.spritesheet('NinjaAttack','images/SpriteSheet/NinjaAttack.png',{frameWidth:536,frameHeight:495})
    this.load.spritesheet('NinjaIdle','images/SpriteSheet/NinjaIdle.png',{frameWidth:232,frameHeight:439})
    this.load.spritesheet('Object','images/SpriteSheet/Object.png',{frameWidth:223,frameHeight:464})
    this.load.spritesheet('NinjaJump', 'images/SpriteSheet/NinjaJump2.png',{frameWidth:362, frameHeight:483 })
    this.load.spritesheet('NinjaClimb','images/SpriteSheet/NinjaClimb.png',{frameWidth:282, frameHeight:464})
    this.load.spritesheet('EnemyIdle','images/SpriteSheet/EnemyIdle.png',{frameWidth:290,frameHeight:500})
    this.load.spritesheet('EnemyDead','images/SpriteSheet/EnemyDead.png',{frameWidth:615, frameHeight:599})
    

    this.load.image('Platform','images/groundProject.png')
    this.load.image('Kunai','images/KunaiRight.png')
    this.load.image('Venom','images/venom.png')
    this.load.image('Background1','images/background 1.jpg')
    this.load.image('Background2','images/Background 2.png')
    this.load.image('DoorLocked','images/DoorLocked.png')
    this.load.image('DoorOpen','images/DoorOpen.png')
    this.load.image('DoorUnlocked','images/DoorUnlocked.png')
    this.load.image('ButtonSilver','images/ButtonSilver.png')
    this.load.image('ButtonGold','images/ButtonGold.png')
    this.load.image('Background3','images/background 3.jpg')
    this.load.image('Barrel1','images/Barrel (1).png')
    this.load.image('Barrel2','images/Barrel (2).png')

}

create()
{
    

    this.add.image(960,540,'Background3')
    
    

    this.Platforms = this.physics.add.staticGroup()
    

    for (let i =1; i<= 4; i++){
    const x = 350 
    const y = 250 * i

    const platformChild = this.Platforms.create(x,y,'Platform')
    platformChild.setScale(0.25)
    platformChild.refreshBody()
    const body = platformChild.body } 
    
    this.Barrels = this.physics.add.staticGroup()
    
    for (let m =1; m<=15; m++){
        const x = 550 
        const y = 50 * m 
        
    const barrelChild = this.Barrels.create(x,y + 200, 'Barrel1')
    barrelChild.setScale(0.25)
    barrelChild.refreshBody()
    const body = barrelChild }

    /*for (let p= 1; p<=3; p++){
        const x = 1700
        const y = 250 * p

        const platformChild = this.Platforms.create(x,y,'Platform')
        platformChild.setScale(0.25)
        platformChild.refreshBody()
        const body = platformChild.body 
    }
    */

    this.player = this.physics.add.sprite(100,600,'NinjaIdle').setScale(0.25)
    this.player.setCollideWorldBounds(true)
    this.player.setBounce(0.25)

    this.player.body.checkCollision.up = false

    
    this.physics.add.collider(this.player,this.Platforms)
    this.physics.add.collider(this.player,this.Barrels)
    /*this.Enemies = this.physics.add.group({
        classType: Enemy,
        maxSize: 3,
        runChildUpdate: true,

    });  
    

    //this.Enemies = this.physics.add.sprite(100,1800,'EnemyIdle')
    
    
    this.enemies = this.Enemies.get(0,0,'EnemyIdle')
    this.Enemy1 = this.enemies.spawn(1600,500)
    /*this.enemies = this.Enemies.get(0,0,'EnemyIdle')
    this.enemies.spawn(1600,400) 

    
    this.physics.add.collider(this.enemies,this.Platforms) */
    
    
    //making doors 
    this.doors = this.physics.add.staticGroup({})
    this.doors.create(400,160,'DoorOpen').setScale(0.25).setDepth(5).refreshBody()

     

    

    
    this.anims.create({
        key: 'jump',
        frames: this.anims.generateFrameNumbers('NinjaJump',{start: 0, end: 9}),
        frameRate: 10,
        repeat: -1
    })
    this.anims.create({
        key:'idle',
        frames:this.anims.generateFrameNumbers('NinjaIdle',{start: 0, end: 7}),
        frameRate: 10,
        
    })
    this.anims.create({
        key: 'right',
        frames: this.anims.generateFrameNumbers('NinjaRun',{start: 0, end: 7}),
        frameRate: 10,
        repeat: -1
    })
    this.anims.create({
        key: 'left',
        frames: this.anims.generateFrameNumbers('NinjaRun',{start: 0, end: 7}.reverse),
        frameRate: 10,
        repeat: -1 
    })
    this.anims.create({
        key:'down',
        frames: this.anims.generateFrameNumbers('NinjaClimb',{start:0, end: 5}),
        frameRate: 10,
        repeat: -1
    })
    this.anims.create({
        key: 'throwKunai',
        frameRate: 2,
        frames: this.anims.generateFrameNumbers('NinjaAttack',{start:0, end: 9})
    })
    
    
    //making kunai
    this.kunais = this.physics.add.group({
        classType: Kunai,
        maxSize: 1,
        runChildUpdate: true,
        allowGravity: false
    })

    this.physics.add.collider(this.kunais,this.Barrels,this.hitBarrels,null,this)
    
    // score 
    this.scoreText = this.add.text (960,100, 'Score :' + this.score + '/300'  ,{fontSize:'50px', fill:'white'}).setOrigin(0.5);

    //this.add.text(960,200,'TARGET THE GOLD BUTTON',{fontSize:'50px', fill: 'black', fontFamily:'bold'}).setOrigin(0.5).setScale(0.75);
    this.add.text(960,200,'SilverButton = 0',{fontSize:'50px',fill: 'Red',fontFamily:'bold'}).setOrigin(0.5).setScale(0.75)
    this.add.text(960,50,'EXPERT - LEVEL', {fontSize:'75px',fill: '#08B9F2 ',fontFamily:'Sans-serif',fontStyle:'Verdana'}).setOrigin(0.5).setScale(3.75)

    
    /*this.physics.add.overlap(
        this.kunais,
        this.enemies,
        this.hitenemy,
        undefined,
        this) */
        
    //making player and doors 
    this.physics.add.overlap(
        this.player,
        this.doors,
        this.teleport,
        undefined,
        this
    )
    
    this.timerLabel = this.add.text(960,150,null).setOrigin(0.5)
    this.timedEvent = this.time.addEvent({
        delay: 3000, // decreaseing every 1 sec 
        callback: this.gameOver,
        callbackScope: this,
        loop: true
    })
    

    
    this.ButtonsSilver = this.physics.add.group()
    this.time.addEvent({
        delay:1000,
        callback: this.SpawnEnemy,
        callbackScope: this,
        loop: true
    })

    this.physics.add.overlap(this.kunais,this.ButtonsSilver, this.hitenemy, null,this)
    
    this.ButtonGold = this.physics.add.group()
    this.time.addEvent({
        delay: 3000,
        callback: this. SpawnGold,
        callbackScope: this,
        loop: true
    })

    this.physics.add.overlap(this.kunais,this.ButtonGold,this.hitJackpot,null,this)


}

update(){
    this.cursors = this.input.keyboard.createCursorKeys()

    if(this.cursors.up.isDown ){
        this.player.setVelocityY(-200)
        this.player.anims.play('jump',true)

    }else if(this.cursors.right.isDown &&  this.player.x<600){
        this.player.setVelocityX(200)
        this.player.anims.play('right',true)
        this.player.setFlipX(false) 
    }
    else if (this.cursors.left.isDown){
        this.player.setVelocityX(-300)
        this.player.anims.play('left',true)
        this.player.setFlipX(true)
    }
    else {this.player.setVelocity(0,200)
        this.player.anims.play('idle',true)
    }

    if(this.cursors.down.isDown){
        this.player.setY(this.player.y + 7)
        this.player.anims.play('down',true)
    }


    if(this.cursors.space.isDown){
        const kunai = this.kunais.get(0,0,'Kunai')
        if(kunai){
            kunai.shot(this.player.x, this.player.y)
            this.player.anims.play('throwKunai',true)
        }
     
    } 

    if(this.score >=300 )
    {
        this.doors.setActive(true).setVisible(true)
        this.ButtonsSilver.setVisible(false)
        this.ButtonGold.setVisible(false)
        if(this.checkPosition == false ){
            this.player.setPosition(180,150)
            this.checkPosition = true
        }
    }
    else this.doors.setActive(false).setVisible(false)

    

    this.timerLabel.setStyle({
        fontSize: '50px',
        fill: '#14ED0D',
        fontstyle: 'bold',
        align: 'center'
    }).setText('TIMER: ' + this.countdownTimer)

}
    hitenemy(Kunai,ButtonsSilver){
        Kunai.erase()
        ButtonsSilver.destroy()

        this.score+=(0)
        this.scoreText.setText('Score:' + this.score + '/300')

    }

    hitJackpot(kunai,ButtonGold){
        kunai.erase()
        ButtonGold.destroy()

        this.score +=(75)
        this.scoreText.setText('Score' + this.score + '/300')
    }

    hitBarrels(kunai,Barrel){
        kunai.erase()
        Barrel.destroy()

    }


    teleport(player,doors){
        if(this.score >= 300 )
        this.sound.stopAll()
        {
        this.scene.start('game-win-scene')}
        
    }

    gameOver(){
    if(this.countdownTimer == 0){
            this.add.text(950,600,'The Time Is Up - You LOSE ! ',{fontSize:'30px'}).setOrigin(0.5)
            this.sound.stopAll
            this.scene.start('game-over-scene')
    }else{this.countdownTimer -= 1}

    }
    SpawnEnemy()
    {
        if(this.ButtonsSilver.countActive(true)<5){
            this.Button = this.ButtonsSilver.create(Phaser.Math.Between(800,1200),0,'ButtonSilver')
      this.Button.setScale(0.25).setBounce(1).setCollideWorldBounds(true).refreshBody()

      this.Button.setVelocity(0,Phaser.Math.Between(800,0))
        }
    }

    SpawnGold()
    {
       if(this.ButtonGold.countActive(true)<5) {
           this.Button = this.ButtonGold.create(Phaser.Math.Between(1400,1900),0,'ButtonGold')
           this.Button.setScale(0.5).setBounce(1).setCollideWorldBounds(true).refreshBody()

           this.Button.setVelocity(0,Phaser.Math.Between(1400,0))
       } 
    }
}




















